import * as React from "react";
import {CommonHelpers} from "@falcon/services";

export class DashcamBanner extends React.Component {


    public render() {
        const showDate = process.env.REACT_APP_DASHCAM_BANNER_SHOW_DATE;
        const hideDate = process.env.REACT_APP_DASHCAM_BANNER_HIDE_DATE;

        const dashcamFromDate = showDate ? CommonHelpers.getDate(showDate) : undefined;
        const dashcamToDate = hideDate ? CommonHelpers.getDate(hideDate) : undefined;
        const today = new Date();

        const showBanner = (dashcamFromDate === undefined) ? false :
            (today >= dashcamFromDate && (dashcamToDate === undefined || today <= dashcamToDate));

        return (
            showBanner ? <div className="banner">
                <div className="banner-content">
                    <div className="banner-text">
                        We’ve teamed up with Road Angel to offer you an exclusive 50% off an award winning dashcam.
                        <p style={{ textAlign: 'right' }}>
                          <a href="https://www.allianz.co.uk/insurance/car-insurance/customer-offers/road-angel.html">Find out more</a>
                        </p>
                    </div>
                </div>
            </div> : <></>
        )
    }
}
